<template>
    <i aria-hidden="true" class="v-icon mdi mdi-check-circle-outline" style="font-size: 28px; color: grey;">
    </i>
</template>

<script>
  export default {

  }
</script>

<style lang="scss" scoped>
.mdi-check-circle-outline::before {
    content: "\F05E1";
}

.mdi:before {
    display: inline-block;
    font: normal normal normal 24px/1 "Material Design Icons";
    font-size: inherit;
    text-rendering: auto;
    line-height: inherit;
    -webkit-font-smoothing: antialiased;
}

</style>



// WEBPACK FOOTER //
// src/components/base/icons/RoundedCheckIcon.vue